module.exports = __webpack_public_path__ + "static/media/settings.9cba7f7a.svg";